// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wqqlF","newExpiryDate":"styles_newExpiryDate__28rMn","footer":"styles_footer__Ux0Zm"};